/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CorrectRunClockRequest,
    CorrectRunClockRequestFromJSON,
    CorrectRunClockRequestToJSON,
} from '../models/CorrectRunClockRequest';
import {
    type CorrectRunClockResponse,
    CorrectRunClockResponseFromJSON,
    CorrectRunClockResponseToJSON,
} from '../models/CorrectRunClockResponse';
import {
    type GetDevicesRequest,
    GetDevicesRequestFromJSON,
    GetDevicesRequestToJSON,
} from '../models/GetDevicesRequest';
import {
    type GetDevicesResponse,
    GetDevicesResponseFromJSON,
    GetDevicesResponseToJSON,
} from '../models/GetDevicesResponse';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';
import {
    type ListDeviceEventsRequest,
    ListDeviceEventsRequestFromJSON,
    ListDeviceEventsRequestToJSON,
} from '../models/ListDeviceEventsRequest';
import {
    type ListDeviceEventsResponse,
    ListDeviceEventsResponseFromJSON,
    ListDeviceEventsResponseToJSON,
} from '../models/ListDeviceEventsResponse';
import {
    type ListDevicesResponse,
    ListDevicesResponseFromJSON,
    ListDevicesResponseToJSON,
} from '../models/ListDevicesResponse';
import {
    type SetRunIntentRequest,
    SetRunIntentRequestFromJSON,
    SetRunIntentRequestToJSON,
} from '../models/SetRunIntentRequest';
import {
    type SetRunIntentResponse,
    SetRunIntentResponseFromJSON,
    SetRunIntentResponseToJSON,
} from '../models/SetRunIntentResponse';

export interface CorrectRunClockOperationRequest {
    /**
     * 
     */
    correctRunClockRequest: CorrectRunClockRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface GetDevicesOperationRequest {
    /**
     * 
     */
    getDevicesRequest: GetDevicesRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ListDeviceEventsOperationRequest {
    /**
     * 
     */
    listDeviceEventsRequest: ListDeviceEventsRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ListDevicesRequest {
    /**
     * 
     */
    accessToken?: string | null;
}

export interface SetRunIntentOperationRequest {
    /**
     * 
     */
    setRunIntentRequest: SetRunIntentRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

/**
 * 
 */
export class DevicesApi extends runtime.BaseAPI {

    /**
     * Creates request options for correctRunClock without sending the request
     */
    async correctRunClockRequestOpts(requestParameters: CorrectRunClockOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['correctRunClockRequest'] == null) {
            throw new runtime.RequiredError(
                'correctRunClockRequest',
                'Required parameter "correctRunClockRequest" was null or undefined when calling correctRunClock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/devices/correct-run-clock`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CorrectRunClockRequestToJSON(requestParameters['correctRunClockRequest']),
        };
    }

    /**
     * Manually correct a run\'s clock (see app.ingestion.clock_shift).  The correction is a claim about the truth, stated relative to what\'s currently displayed; it folds into a single per-run manual shift (net overwrite semantics) and pins the run against later automatic shifts.
     * Correct Run Clock
     */
    async correctRunClockRaw(requestParameters: CorrectRunClockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorrectRunClockResponse>> {
        const requestOptions = await this.correctRunClockRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorrectRunClockResponseFromJSON(jsonValue));
    }

    /**
     * Manually correct a run\'s clock (see app.ingestion.clock_shift).  The correction is a claim about the truth, stated relative to what\'s currently displayed; it folds into a single per-run manual shift (net overwrite semantics) and pins the run against later automatic shifts.
     * Correct Run Clock
     */
    async correctRunClock(requestParameters: CorrectRunClockOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorrectRunClockResponse> {
        const response = await this.correctRunClockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDevices without sending the request
     */
    async getDevicesRequestOpts(requestParameters: GetDevicesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['getDevicesRequest'] == null) {
            throw new runtime.RequiredError(
                'getDevicesRequest',
                'Required parameter "getDevicesRequest" was null or undefined when calling getDevices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/devices/get`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDevicesRequestToJSON(requestParameters['getDevicesRequest']),
        };
    }

    /**
     * Get Devices
     */
    async getDevicesRaw(requestParameters: GetDevicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDevicesResponse>> {
        const requestOptions = await this.getDevicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDevicesResponseFromJSON(jsonValue));
    }

    /**
     * Get Devices
     */
    async getDevices(requestParameters: GetDevicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDevicesResponse> {
        const response = await this.getDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listDeviceEvents without sending the request
     */
    async listDeviceEventsRequestOpts(requestParameters: ListDeviceEventsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['listDeviceEventsRequest'] == null) {
            throw new runtime.RequiredError(
                'listDeviceEventsRequest',
                'Required parameter "listDeviceEventsRequest" was null or undefined when calling listDeviceEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/devices/events/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListDeviceEventsRequestToJSON(requestParameters['listDeviceEventsRequest']),
        };
    }

    /**
     * List Device Events
     */
    async listDeviceEventsRaw(requestParameters: ListDeviceEventsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDeviceEventsResponse>> {
        const requestOptions = await this.listDeviceEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDeviceEventsResponseFromJSON(jsonValue));
    }

    /**
     * List Device Events
     */
    async listDeviceEvents(requestParameters: ListDeviceEventsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDeviceEventsResponse> {
        const response = await this.listDeviceEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listDevices without sending the request
     */
    async listDevicesRequestOpts(requestParameters: ListDevicesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/devices/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Devices
     */
    async listDevicesRaw(requestParameters: ListDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDevicesResponse>> {
        const requestOptions = await this.listDevicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDevicesResponseFromJSON(jsonValue));
    }

    /**
     * List Devices
     */
    async listDevices(requestParameters: ListDevicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDevicesResponse> {
        const response = await this.listDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setRunIntent without sending the request
     */
    async setRunIntentRequestOpts(requestParameters: SetRunIntentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['setRunIntentRequest'] == null) {
            throw new runtime.RequiredError(
                'setRunIntentRequest',
                'Required parameter "setRunIntentRequest" was null or undefined when calling setRunIntent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/devices/set-run-intent`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetRunIntentRequestToJSON(requestParameters['setRunIntentRequest']),
        };
    }

    /**
     * Override (or clear the override of) a run\'s fishing/testing intent. The device\'s own session_intent events are left as they are. A run that becomes fishing posts its already-eligible captures to the team feed now, since the gate had been declining them.
     * Set Run Intent
     */
    async setRunIntentRaw(requestParameters: SetRunIntentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetRunIntentResponse>> {
        const requestOptions = await this.setRunIntentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetRunIntentResponseFromJSON(jsonValue));
    }

    /**
     * Override (or clear the override of) a run\'s fishing/testing intent. The device\'s own session_intent events are left as they are. A run that becomes fishing posts its already-eligible captures to the team feed now, since the gate had been declining them.
     * Set Run Intent
     */
    async setRunIntent(requestParameters: SetRunIntentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetRunIntentResponse> {
        const response = await this.setRunIntentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
